import { render } from "./NavBar.vue?vue&type=template&id=31701ba4"
import script from "./NavBar.vue?vue&type=script&lang=ts"
export * from "./NavBar.vue?vue&type=script&lang=ts"

import "./NavBar.vue?vue&type=style&index=0&id=31701ba4&lang=css"
script.render = render

export default script